import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import translate from '../../../commonComponents/translate';
import ReportBtnTab from './ReportBtnTab';
import ReportTabProp, { REPORT_TAB_TYPE } from '../propTypes/reportTabProp';
import ConfigsContext from '../../../contextProviders/ConfigsContext';

function ReportTabBtns(props) {
  const { t, tabActive } = props;
  const { organization, tenant } = useContext(ConfigsContext);
  const { tailorMadeAdminReports = [] } = organization || {};
  const hasNeofinReport = tailorMadeAdminReports.find(
    tailor => tailor === 'neofin_team_report',
  );

  const organizationTailorMadeReports =
    organization.tailorMadeAdminReports || [];
  const tenantTailorMadeReports = tenant.tailorMadeAdminReports || [];

  const showBonus =
    organizationTailorMadeReports.includes('pureliink_bonus_report') ||
    tenantTailorMadeReports.includes('pureliink_bonus_report');

  return (
    <div className="reportTabContainer">
      {showBonus ? (
        <ReportBtnTab
          isActive={tabActive === REPORT_TAB_TYPE.BONUS_LIST}
          label={t('header_bonusList')}
          link="/reports/bonus-list"
        />
      ) : null}
      {hasNeofinReport ? (
        <ReportBtnTab
          isActive={tabActive === REPORT_TAB_TYPE.NEOFIN_TEAM_REPORT}
          label={t('myReports.teamReport')}
          link="/reports"
        />
      ) : null}
      <ReportBtnTab
        isActive={tabActive === REPORT_TAB_TYPE.SCORM}
        label={t('team.report.scorm.tab')}
        link="/reports/academy/scorm"
      />
      <ReportBtnTab
        isActive={tabActive === REPORT_TAB_TYPE.PERFORM}
        label={t('team.report.perform.tab')}
        link="/reports/perform"
      />
    </div>
  );
}

ReportTabBtns.propTypes = {
  t: PropTypes.func.isRequired,
  tabActive: PropTypes.oneOf(ReportTabProp.REPORT_TAB_TYPES).isRequired,
};

export default translate(ReportTabBtns);
